import { ServiceResponse } from '@sdbn/appclient';
import { TargetTransport } from './target-transport';
export class UmbrueckungDetails extends ServiceResponse {

  id: number;
  carrier: string;
  name: string;
  identifier: string;
  transportScope: string;
  currentStationId: number;
  swapTrailerNumber: string;
  trailerNumberPlate: string;
  targetTransports: TargetTransport[] = [];

  constructor(details: any) {
    super(details);
    this.id = details.number;
    this.carrier = details.string;
    this.name = details.string;
    this.identifier = details.string;
    this.transportScope = details.string;
    this.currentStationId = details.number;
    this.swapTrailerNumber = details.string;
    this.trailerNumberPlate = details.string;
    if (details.targetTransports != null) {
      for (const t of details.targetTransports) {
        this.targetTransports.push(new TargetTransport(t));
      }
    }
  }
}
